module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Total Participants")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Review participant totals by live session and date range")])])]), _vm._v(" "), _c('section', {
    staticClass: "tp-filter-card"
  }, [_c('div', {
    staticClass: "tp-card-header"
  }, [_c('span', {
    staticClass: "tp-icon-pill"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 2v4M8 2v4M3 10h18"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tp-header-copy"
  }, [_c('h2', {
    staticClass: "tp-card-title"
  }, [_vm._v("Date Range")]), _vm._v(" "), _c('p', {
    staticClass: "tp-card-subtitle"
  }, [_vm._v("Filter sessions by start and end date")])])]), _vm._v(" "), _c('div', {
    staticClass: "tp-date-row"
  }, [_c('date-range-field', {
    model: {
      value: (_vm.rangeData),
      callback: function($$v) {
        _vm.rangeData = $$v
      },
      expression: "rangeData"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "tp-table-card"
  }, [_c('div', {
    staticClass: "tp-card-header tp-card-header--split"
  }, [_c('div', {
    staticClass: "tp-header-left"
  }, [_c('span', {
    staticClass: "tp-icon-pill"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 21v-2a4 4 0 0 0-3-3.87"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tp-header-copy"
  }, [_c('h2', {
    staticClass: "tp-card-title"
  }, [_vm._v("Participant Sessions")]), _vm._v(" "), _c('p', {
    staticClass: "tp-card-subtitle"
  }, [_vm._v("Click a row to open the session detail in a new tab")])])]), _vm._v(" "), _c('div', {
    staticClass: "tp-summary-strip"
  }, [_c('span', {
    staticClass: "tp-summary-pill"
  }, [_c('span', {
    staticClass: "tp-summary-label"
  }, [_vm._v("Rows")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.loading ? '...' : _vm.tableData.length))])]), _vm._v(" "), _c('span', {
    staticClass: "tp-summary-pill tp-summary-pill--primary"
  }, [_c('span', {
    staticClass: "tp-summary-label"
  }, [_vm._v("Total TP")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.loading ? '...' : _vm.formattedTotalParticipants))])])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "tp-skeleton-table"
  }, [_c('div', {
    staticClass: "tp-sk-head"
  }, _vm._l((5), function(n) {
    return _c('div', {
      key: 'tp-head-' + n,
      staticClass: "tp-sk-cell sk-shimmer"
    })
  }), 0), _vm._v(" "), _vm._l((6), function(row) {
    return _c('div', {
      key: 'tp-row-' + row,
      staticClass: "tp-sk-row"
    }, _vm._l((5), function(col) {
      return _c('div', {
        key: 'tp-row-' + row + '-col-' + col,
        staticClass: "tp-sk-cell sk-shimmer"
      })
    }), 0)
  })], 2) : (_vm.tableData.length) ? _c('div', {
    staticClass: "tp-table-wrap"
  }, [_c('v-table', {
    staticClass: "tp-easy-table",
    attrs: {
      "is-horizontal-resize": "",
      "columns": _vm.columns,
      "table-data": _vm.tableData,
      "show-vertical-border": true,
      "title-row-height": 38,
      "border": 1,
      "footer": _vm.footer,
      "footer-row-height": 42,
      "footer-cell-class-name": _vm.setFooterCellClass,
      "row-hover-color": "#fafafa",
      "row-click": _vm.raceDetail
    }
  })], 1) : _c('div', {
    staticClass: "tp-empty"
  }, [_c('svg', {
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 21v-2a4 4 0 0 0-3-3.87"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("No participant sessions found for this date range.")])]), _vm._v(" "), (!_vm.loading && _vm.pageTotal) ? _c('div', {
    staticClass: "tp-pagination"
  }, [_c('v-pagination', {
    attrs: {
      "total": _vm.pageTotal,
      "pageIndex": _vm.pageIndex + 1,
      "page-size": _vm.pageSize,
      "layout": ['total', 'prev', 'pager', 'next', 'sizer', 'jumper']
    },
    on: {
      "page-change": _vm.pageChange,
      "page-size-change": _vm.pageSizeChange
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb1ca8b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TP.vue
// module id = 1761
// module chunks = 2